<template>
  <v-footer>
    <div class="footer-bottom">
      <v-container>
        <v-row>
          <v-col cols="12" md="12" class="text-center mt-3 mb-2">
            <a href="/homepage" class="logo-anchor footer-logo"
              ><img style="width: 300px;" src="/static/footer-logo.png"
            /></a>
          </v-col>
        </v-row>
      </v-container>
      <hr />
      <v-container>
        <v-row class="d-flex justify-content-center">
          <v-col cols="12" sm="12" md="6" lg="3" class="mt-10 black--text">
            <h3 class="footer-sub-title">IMPROVE</h3>
            <div class="footer-links">
              <a href="/homepage">Why IMPROVE?</a>
              <a href="/features">Features</a>
              <a href="/course-library">Course Library</a>
              <a href="/pricing">Pricing</a>
              <a href="/faq">FAQ</a>
              <a href="/blog">Blog</a>
              <a href="/about-us">About Us</a>
              <a href="/request">Request a Demo</a>
              <a href="/contact">Contact</a>
            </div>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="3"
            class="mt-10 black--text center"
          >
            <h3 class="footer-sub-title ">Courses</h3>
            <div class="footer-links">
              <a href="/course-library?course=Compliance"
                >Compliance</a
              >
              <a href="/course-library?course=PeopleAndRelationships"
                >People & Relationships</a
              >
              <a href="/course-library?course=ManagementAndLeadershipCourses"
                >Management & Leadership</a
              >
              <a href="/course-library?course=ProjectManagementCourses"
                >Project Management</a
              >
              <a href="/course-library?course=HealthAndSafetyCourses"
                >Health & Safety</a
              >
              <a href="/course-library?course=ITSkillsCourses"
                >IT Skills</a
              >
            </div>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="3" class="mt-10 black--text">
            <h3 class="footer-sub-title">Terms & Policies</h3>
            <div class="footer-links">
              <a href="/privacy-policy">Privacy Policy</a>
              <a href="/eula">End user license agreement</a>
              <a href="/usage-policy">Terms of use policy</a>
            </div>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="3" class="mt-10 black--text">
            <h3 class="footer-sub-title">Contact</h3>
            <div class="footer-links">
              <a
                href="mailto:hello@improve.online?subject=Customer%20Inquiry&body=Hello%20Improve%20Team,%0A%0AI%20would%20like%20to%20inquire%20about%20..."
                >hello@improve.com</a
              >
              <a href="tel:+441156786278">0115 6786278</a>
            </div>
            <h5>IMPROVE PRODUCTIONS LIMITED</h5>
            <span class="footer-item">Unit 11</span>
            <span class="footer-item">Wheatcroft Business Park</span>
            <span class="footer-item">Landmere Lane</span>
            <span class="footer-item">Edwalton</span>
            <span class="footer-item">Nottingham</span>
            <span class="footer-item">NG12 4DG</span>
            <span class="footer-item">United Kingdom</span>
            <div class="company-social">
              <a
                href="https://www.linkedin.com/company/improveonline"
                target="_blank"
                ><img src="/static/icons/improve-linkedin.png"
              /></a>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <hr />
      <div>
        <v-col cols="12" class="text-center">
          <span class="footer-company-sub-title">
            © {{ currentYear }} IMPROVE PRODUCTIONS LIMITED | Registered Company Number:
            11320233
          </span>
        </v-col>
      </div>
    </div>
  </v-footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      currentYear: new Date().getFullYear()
    };
  }
};
</script>

<style>
.footer-logo {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}

.footer-sub-title {
  font-size: 18px;
  font-weight: bold;
  color: #122034;
  margin-bottom: 15px;
}

.footer-item {
  font-size: 13px;
  color: #333333;
  margin: 0;
  padding: 0;
  display: block;
}

.footer-links a {
  font-size: 13px;
  color: #333333;
  font-weight: normal;
  line-height: 32px;
  display: block;
  text-decoration: none;
}
.company-social {
  margin-top: 10px;
}

.footer-company-sub-title {
  font-size: 11px;
  font-weight: normal;
  color: #333333;
  margin-bottom: 15px;
}

@media (max-width: 1264px) {
  .footer-bottom {
    text-align: center !important;
  }
}
</style>
